import {IconButton, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AgGridReact} from "ag-grid-react";
import {useMemo, useRef} from "react";
import {ColDef, ICellRendererParams, SideBarDef} from "ag-grid-community";
import {DescriptionRounded} from "@mui/icons-material";
import {Link} from "react-router-dom";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";

import {useHasScope} from "../../../../config/globalConfig";
import { NetworkScope } from "../../types";
import { IRsTable } from "./types";

const RsTable = ({serverSideDatasource}: IRsTable) => {
    const {t, i18n} = useTranslation(['network', 'translation']);
    const hasScope = useHasScope;
    const gridRef = useRef<AgGridReact>(null);
    
    const searchLbl= "searchRs.form.label";

    const sideBar = useMemo<SideBarDef>(() => ({
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnExpandAll: true,
                },
            },
        ],
        defaultToolPanel: '',
    }), []);

    const columnDefs = useMemo<ColDef[]>(() => [
        {
            field: 'generalInfo.id',
            headerName: "",
            width: 70,
            resizable: false,
            suppressMovable: true,
            suppressSizeToFit: false,
            suppressColumnsToolPanel: true,
            pinned: 'right',
            cellRenderer: (params: ICellRendererParams) => {
                const url = `/mobility-store/repair-shop/${params.data?.id}`;
                
                return (
                    hasScope( NetworkScope.MsDetail) &&
                    <Stack direction={"row"} justifyContent={"center"}>
                        <Link to={url} target="_blank">
                            <IconButton color="accent">
                                <DescriptionRounded />
                            </IconButton>
                        </Link>
                    </Stack>
                );
            }
        },
        {headerName: t(`${searchLbl}.rsNaming`), field: 'nameCode.description', sortable: true},
        {headerName: t(`${searchLbl}.rsCode`), field: 'identificationCode', sortable: true},
        {headerName: t(`${searchLbl}.rsSapId`), field: 'nameCode.code', sortable: true},
        {headerName: t(`${searchLbl}.rsCategory`), field: 'category', sortable: true},
        {headerName: t(`${searchLbl}.currentStatus`), field: 'currentStatus', sortable: true},
        {headerName: t(`${searchLbl}.currentAttribute`), field: 'currentAttribute', sortable: true},
        {headerName: t(`${searchLbl}.region`), field: 'region', sortable: true},
        {headerName: t(`${searchLbl}.province`), field: 'province', sortable: true},
        {headerName: t(`${searchLbl}.city`), field: 'city', sortable: true},
        {headerName: t(`${searchLbl}.address`), field: 'address', sortable: true},
        {headerName: t(`${searchLbl}.streetNr`), field: 'streetNumber', sortable: true},
        {headerName: t(`${searchLbl}.chargingStationIdCode`), field: 'chargingStationIdentificationCode', sortable: true},
        {headerName: t(`${searchLbl}.chargingStationStatus`), field: 'chargingStationStatus', sortable: true},
        {headerName: t(`${searchLbl}.certificationProtocolId`),field: 'certificationProtocolIdentificationCode', sortable: true},
    ], [i18n.language] );


    return (
        <AgGridCustomTable
            gridRef={gridRef}
            rowModelType='serverSide'
            serverSideInfiniteScroll
            serverSideDatasource={serverSideDatasource}
            columnDefs={columnDefs}
            gridOptions={{defaultColDef: { lockPinned: true, resizable: true, suppressSizeToFit: true }}}
            sideBar={sideBar}
        />
    )
}

export default RsTable;
